import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2, BookOpen, TerminalSquare, Layers, Target, ListChecks } from 'lucide-react';
export function Deliverables() {
  const items = [{
    icon: <BookOpen className="w-6 h-6 text-gold" data-id="element-14" />,
    title: 'Guía Maestra InstaPrint AI',
    desc: 'El paso a paso desde la idea hasta el dólar.'
  }, {
    icon: <TerminalSquare className="w-6 h-6 text-gold" data-id="element-15" />,
    title: 'Prompt Library Master',
    desc: "Más de 50 comandos 'copia y pega' para crear arte Bestseller."
  }, {
    icon: <Layers className="w-6 h-6 text-gold" data-id="element-16" />,
    title: 'La Fórmula de los 5 Elementos',
    desc: "El secreto para que tus imágenes no parezcan 'hechas por computadora'."
  }, {
    icon: <Target className="w-6 h-6 text-gold" data-id="element-17" />,
    title: 'Guía de Nichos de Oro',
    desc: 'Lista de los 3 temas que más venden las madres en USA hoy.'
  }, {
    icon: <ListChecks className="w-6 h-6 text-gold" data-id="element-18" />,
    title: 'Checklist de Configuración',
    desc: 'Crea tu tienda digital optimizada en tiempo récord.'
  }];
  return <section className="py-16 md:py-24 bg-white px-4 sm:px-6 lg:px-8" data-id="element-19">
      <div className="max-w-5xl mx-auto" data-id="element-20">
        <FadeIn data-id="element-21">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-center text-darkText mb-16" data-id="element-22">
            Lo que obtienes hoy
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-23">
          {items.map((item, idx) => <FadeIn key={idx} delay={idx * 0.1} data-id="element-24">
              <div className="bg-cream/30 p-6 rounded-2xl border border-lavender/20 h-full hover:shadow-card transition-shadow" data-id="element-25">
                <div className="flex items-start gap-4" data-id="element-26">
                  <div className="mt-1 bg-white p-2 rounded-full shadow-sm" data-id="element-27">
                    {item.icon}
                  </div>
                  <div data-id="element-28">
                    <h3 className="text-lg font-bold text-darkText mb-2" data-id="element-29">
                      {item.title}
                    </h3>
                    <p className="text-lightText text-sm leading-relaxed" data-id="element-30">
                      {item.desc}
                    </p>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}